import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { CourseLearningResult } from '../types/details';

export const useColumnsLearningUnits = () => {
  const { t } = useTranslation(TranslationsKeys.COURSES_DETAILS);
  return useMemo<ColumnTable<CourseLearningResult>[]>(() => {
    return [
      {
        columnName: 'title',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`learningUnit.table.columns.title`),
        width: '42%',
      },
      {
        columnName: 'hours',
        thClassName: 'text-center',
        tdClassName: 'text-center p-0 ',
        headerText: t(`learningUnit.table.columns.hours`),
        width: '42%',
      },
    ];
  }, [t]);
};
